<template>
  <main-content>
    <div class="container">
      <div class="row margin-above">
        <div class="col-md-8 mx-auto text-center">
          <div class="card bg-success text-center border-rounded p-4 mb-4" v-if="walletStatus === 'SUCCEED'">
            <h4 class="text-white">{{ $t('label.success_payment') }}</h4>
          </div>
          <div class="card bg-danger text-center border-rounded p-4 mb-4" v-else>
            <h4 class="text-white">{{ $t('label.cancel_payment') }}</h4>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mx-auto text-center">
            <router-link to="/wallets" class="btn btn-success">{{ $t('wallets.receipt.back_to_wallet') }}</router-link>
        </div>
      </div>
    </div>
  </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import {
  walletTransactionStatus,
  walletTransactionStatusStr,
} from "@/constants/walletTransactionStatus";
import Axios from "axios";
export default {
  name: "walletCheckStatus",
  data() {
    return {
      walletTransactionStatus,
      walletTransactionStatusStr,
      walletStatus: null,
    };
  },
  components: {
    MainContent,
  },
  async mounted() {
    Axios.get(`transaction?query[ref_id]=${this.$route.params.id}`)
      .then((response) => {
        console.log(response.data.data.data[0].status);
        this.walletStatus = response.data.data.data[0].status
      })
      .catch((error) => {
        throw new Error(error)
      });
  },
};
</script>

<style scoped>
.margin-above {
  margin: 14rem 0 0 0;
}
</style>
